import { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { getQueryParam } from '../../lib/utils';
import { CommonDialog } from '../shared/dialog/CommonDialog';

export const DeleteFailedDialog = () => {
  const { t } = useTranslation(['my_design', 'translation']);
  const location = useLocation();
  const design = getQueryParam(location.search || '', 'design');
  const isPro = design === 'pro';
  const title = t('translation:dialog_error');
  const description = getText(t, isPro);
  return <CommonDialog title={title} description={description} />;
};

function getText(t: TFunction, isPro: boolean): string {
  if (isPro) {
    return t('delete_failed_desc_no_exist_pro');
  } else {
    return t('delete_failed_desc_no_exist');
  }
}
